// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout        from "./components/Layout";
import Login         from "./pages/Login";
import Dashboard     from "./pages/Dashboard";
import Performance   from "./pages/Performance";
import TakeTest      from "./pages/TakeTest";
import TestSession   from "./pages/TestSession";
import TestResult    from "./pages/TestResult";
import AdaptivePractice from "./pages/AdaptivePractice";
import PracticeSession  from "./pages/PracticeSession";
import Results       from "./pages/Results";
import JobPostings   from "./pages/JobPostings";
import GKNews        from "./pages/GKNews";
import VideoResources from "./pages/VideoResources";
import PreviousPapers from "./pages/PreviousPapers";
import CheatSheet    from "./pages/CheatSheet";
import AIChat        from "./pages/AIChat";
import SyllabusPlanner from "./pages/SyllabusPlanner";
import Coding          from "./pages/Coding";

function Private({ children }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Private><Layout /></Private>}>
          <Route index                  element={<Dashboard />} />
          <Route path="performance"     element={<Performance />} />
          <Route path="test"            element={<TakeTest />} />
          <Route path="test/session"    element={<TestSession />} />
          <Route path="test/result"     element={<TestResult />} />
          <Route path="practice"        element={<AdaptivePractice />} />
          <Route path="practice/session" element={<PracticeSession />} />
          <Route path="results"         element={<Results />} />
          <Route path="jobs"            element={<JobPostings />} />
          <Route path="gk-news"         element={<GKNews />} />
          <Route path="resources"       element={<VideoResources />} />
          <Route path="papers"          element={<PreviousPapers />} />
          <Route path="cheat-sheets"    element={<CheatSheet />} />
          <Route path="ai-tutor"       element={<AIChat />} />
          <Route path="planner"        element={<SyllabusPlanner />} />
          <Route path="coding"         element={<Coding />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
